// extracted by mini-css-extract-plugin
module.exports = {"legendWrapper":"maplegend_legendWrapper__4TVz9","legendItem":"maplegend_legendItem__6heVx","nord":"maplegend_nord__5qKCI"};